export default __webpack_public_path__ + "static/media/one.30d4aff7.jpg";